import { render } from "./Title.vue?vue&type=template&id=4b500bac&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=4b500bac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b500bac"

export default script